import React from 'react';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { CreditCard, Link, Zap } from 'lucide-react';
import { Control } from "react-hook-form";

interface PaymentOptionsToggleProps {
  control: Control<any>;
  isLoading: boolean;
  watchPaymentOption: string;
}

const PaymentOptionsToggle: React.FC<PaymentOptionsToggleProps> = ({
  control,
  isLoading,
  watchPaymentOption
}) => {
  return (
    <FormField
      control={control}
      name="paymentOption"
      render={({ field }) => (
        <FormItem className="space-y-3">
          <FormLabel className="text-base font-medium">Payment Link Options</FormLabel>
          <FormControl>
            <RadioGroup
              onValueChange={field.onChange}
              value={field.value}
              className="grid grid-cols-1 gap-3"
              disabled={isLoading}
            >
              <div className="flex items-center space-x-3 border rounded-lg p-3 hover:bg-muted/50 transition-colors">
                <RadioGroupItem value="none" id="none" />
                <div className="flex items-center gap-2 flex-1">
                  <CreditCard className="w-4 h-4 text-muted-foreground" />
                  <label htmlFor="none" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer">
                    No payment link
                  </label>
                </div>
              </div>
              
              <div className="flex items-center space-x-3 border rounded-lg p-3 hover:bg-muted/50 transition-colors">
                <RadioGroupItem value="manual" id="manual" />
                <div className="flex items-center gap-2 flex-1">
                  <Link className="w-4 h-4 text-muted-foreground" />
                  <label htmlFor="manual" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer">
                    Add manual payment link
                  </label>
                </div>
              </div>
              
              <div className="flex items-center space-x-3 border rounded-lg p-3 hover:bg-muted/50 transition-colors">
                <RadioGroupItem value="generate" id="generate" />
                <div className="flex items-center gap-2 flex-1">
                  <Zap className="w-4 h-4 text-muted-foreground" />
                  <label htmlFor="generate" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer">
                    Generate payment link automatically
                  </label>
                </div>
              </div>
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default PaymentOptionsToggle;